'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBookMagnifyingGlass, iconBookMagnifyingGlassTag } from '@ni/nimble-components/dist/esm/icons/book-magnifying-glass';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBookMagnifyingGlass };
export { iconBookMagnifyingGlassTag };
export const NimbleIconBookMagnifyingGlass = wrap(IconBookMagnifyingGlass);